import React from 'react';

import { CA, CG } from 'contexts';
import { routes } from 'modules/routes';
import * as List from 'components/list';

import { MenuListModulesItem } from './MenuListModulesItem';
import * as Styled from './StyledMenuListModules';

export function MenuListModules(props) {
    const { state } = React.useContext(CA);
    const { language } = React.useContext(CG).state;
    const { authenticated } = state;

    // Filter the routes to be shown to the user
    const filter = r => {
        // Check if the language is avaliable
        if (r.menuLang && !r.menuLang.includes(language)) {
            return null;
        }
        return r.name && r.icon && (r.private === false || r.private === authenticated);
    };

    const listProps = {
        items: routes.filter(filter),
        itemKey: 'path',
        itemComponent: MenuListModulesItem,
    };
    return !listProps.items.length ? null : (
        <Styled.MenuListModules as={List.List} name="MenuListModules">
            <List.Vertical {...listProps} />
        </Styled.MenuListModules>
    );
}
export default MenuListModules;
